<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 7.32382V3.32383C16 2.72383 15.5 2.32383 15 2.32383H10.9844V1.98633C10.9844 1.48633 10.4844 0.986328 9.98438 0.986328H6C5.5 0.986328 5.01562 1.43321 5.01562 1.98633V2.32383H1C0.5 2.32383 0 2.82383 0 3.32383V7.32382H5.5C5.5 6.82382 5.9 6.42383 6.4 6.42383H9.7C10.2 6.42383 10.7 6.82382 10.7 7.32382H16ZM16 13.9838V8.27053H10.7C10.6 8.77053 10.2 9.17053 9.7 9.17053H6.5C6 9.17053 5.6 8.77053 5.5 8.27053H0V13.9838C0 14.4838 0.5 14.9838 1 14.9838H15C15.6 14.9838 16 14.4838 16 13.9838Z"
    />
  </svg>
</template>
